module.exports = __webpack_public_path__ + "assets/2-Austin-Sales-Careers-Tech.2eb4a198.png";